import { gsap } from "./core/gsap";

const SELECTOR_LINE = '[data-line-animation]';

/**
 * Initialize line animation for all elements with data-line-animation attribute
 * Can be called multiple times - will skip already initialized elements
 */
export function initLineAnimations(container: HTMLElement | Document = document) {
  const lineElements = container.querySelectorAll<HTMLElement>(SELECTOR_LINE);
  
  lineElements.forEach((lineEl) => {
    // Skip if already initialized
    if (lineEl.dataset.lineAnimationInit === 'true') return;

    const opacity = lineEl.dataset.lineOpacity ? parseFloat(lineEl.dataset.lineOpacity) : 0.5;
    const duration = lineEl.dataset.lineDuration ? parseFloat(lineEl.dataset.lineDuration) : 2;

    gsap.set(lineEl, {
      clipPath: 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)',
      opacity: opacity
    });

    gsap.to(lineEl, {
      clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
      duration: duration,
      ease: "power2.out",
      scrollTrigger: {
        trigger: lineEl,
        start: "top 80%",
        end: "top 60%",
        toggleActions: "play none none none",
        once: true
      }
    });

    // Mark as initialized
    lineEl.dataset.lineAnimationInit = 'true';
  });
}

/**
 * Initialize line animations on page load
 */
export function initGlobalLineAnimations() {
  initLineAnimations();
  
  document.addEventListener('shopify:section:load', () => {
    initLineAnimations();
  });
}

